import styled from 'styled-components';

export const TitleSelectionWrapper = styled.div`
  display: flex;
  gap: 2px;
  height: 25px;

  #retailers-by-swamps-locations,
  #retailers-by-density-locations {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
  }

  .BaseSelect__control {
    height: 20px;
    display: flex;
    align-content: center;
    font-size: 12px;
  }

  .BaseSelect__indicators {
    display: flex;
    height: 20px;
  }

  .BaseSelect__indicator {
    width: 14px;
    height: 14px;
    color: black;
    padding: 0;
  }

  .BaseSelect__value-container {
    width: 100px;
    margin: auto;
    padding-left: 2px;
  }

  .BaseSelect__menu {
    font-size: 12px;
  }

  .BaseSelect__option {
    height: 18px;
    padding: 2px;
  }

  .proximity-range {
    .BaseSelect__control {
      width: 95px;
    }
  }
  .proximity-place {
    .BaseSelect__control {
      width: 140px;
    }
  }
`;

export const HeaderSelectionWrapper = styled.div`
  display: flex;
  gap: 2px;
  align-items: baseline;
  height: 24px;
`;

export const SwatchLegendSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SwatchLegendWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;
